module.exports = __webpack_public_path__ + "b02121aead40a45744e19f8c1aac2210.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/crayons.png
// module id = 2378
// module chunks = 0